export default __webpack_public_path__ + "fonts/discover-card.svg";